<template>
  <div class="mt-5 text-center">
    <check-circle
      v-if="parameter === 'Success'"
      scale="4"
      color="orange"
    />
    <exclamation-circle
      v-if="parameter === 'IsConfirmed'"
      scale="4"
      color="orange"
    />
    <h2 class="mt-5">
      {{ content.title }}
    </h2>
    <p class="text-center bold">
      {{ content.description }}
    </p>

    <div class="mt-4">
      <button
        id="btnAceptarHome"
        class="button w-75 text-xl"
        @click="goOut"
      >
        Ir a Mi Claro
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ExclamationCircle, CheckCircle } from '@/components/icons';

export default {
  name: 'RecurringPaymentActivationToken',
  components: { ExclamationCircle, CheckCircle },
  data() {
    return {
      parameter: ''
    };
  },
  computed: {
    ...mapGetters(['creditCard', 'country']),
    content() {
      const messages = this.$t('affiliationResult')[this.parameter];
      return messages;
    }
  },
  created() {
    this.parameter = this.$route.query.result;
  },
  methods: {
    goOut() {
      const urls = {
        GT: 'https://miclaro.com.gt/',
        SV: 'https://miclaro.com.sv/',
        HN: 'https://miclaro.com.hn/',
        NI: 'https://miclaro.com.ni/',
        CR: 'https://miclaro.cr/',
        PA: 'https://miclaro.com.pa/'
      };
      window.location.href = urls[this.country.pais.toUpperCase()];
    }
  }
};
</script>

